import { render, staticRenderFns } from "./weightRange.vue?vue&type=template&id=da094652&scoped=true"
import script from "./weightRange.vue?vue&type=script&lang=js"
export * from "./weightRange.vue?vue&type=script&lang=js"
import style0 from "./weightRange.vue?vue&type=style&index=0&id=da094652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da094652",
  null
  
)

export default component.exports